module.exports = __webpack_public_path__ + "img/m-pop-apology-wavve.9d5edd39.png";